module.exports = __webpack_public_path__ + "static/img/智慧业财管理平台.c2c9d96e.png";